export default __webpack_public_path__ + "static/media/bulk_payment.10e27932.svg";